export default "__VITE_ASSET__f64dced7__"